// extracted by mini-css-extract-plugin
export default {"wrapper":"gE-z","button":"hE-z","alternate":"iE-z","disabled":"jE-z","paymentWarning":"kE-z","fadeIn":"lE-z"};